export const UNASSIGNED = 'UNASSIGNED';
export const USERS_AND_TEAMS = 'USERS_AND_TEAMS';
export const OWNER = 'OWNER';
export const INBOX_USERS = 'INBOX_USERS';
export const BOT = 'BOT';